import { Box, Flex } from '@rebass/grid'
import * as firebase from 'firebase'
import * as moment from 'moment'
import * as R from 'ramda'
import * as React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Button, Divider } from 'semantic-ui-react'
import Icon from 'src/components/Icon'
import { Text } from 'src/elements'
import { RWD } from 'src/elements/RWD'
import { Dispatch, RootState, store } from 'src/store'
import styled from 'styled-components'

const FooterContainer = styled(Flex)`
  position: fixed;
  bottom: 0px;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
`

const ToolbarContainer = styled(Flex)`
  width: 100%;
  height: 68px;
  max-width: 940px;
  padding: 12px 16px;
  justify-content: space-between;
  @media (max-width: 576px) {
    height: 56px;
    padding: 10px 16px;
  }
`

const CTAFooter = ({
  lectureId,
  lecture,
  isSpeaker,
  isParticipant,
  isShow,
  onCTAClose
}: IFooterProps & { isShow: boolean; onCTAClose: () => void }) => {
  const CTAContainer = styled(Flex)`
    width: 100%;
    max-width: 940px;
    padding: 12px 16px;
    justify-content: space-between;
    @media (max-width: 576px) {
      padding: 10px 16px;
    }
  `
  if (!lecture) {
    return null
  }
  if (isSpeaker || isParticipant) {
    return isShow &&
      lecture &&
      new Date() >= lecture.startedAt.toDate() &&
      new Date() <= lecture.endedAt.toDate() ? (
      <RWD.Mobile>
        <CTAContainer alignItems="center" style={{ height: 56 }}>
          <Flex>
            <Box mr={2}>
              <Icon type="lecture-comment" />
            </Box>
            <Box>
              <Text.Content>
                {`講師回覆時段 ${moment(lecture.startedAt.toDate()).format(
                  'MM/DD'
                )} - ${moment(lecture.endedAt.toDate()).format('MM/DD')}`}
              </Text.Content>
            </Box>
          </Flex>
          <Box>
            <Icon type="popup-close" size={18} onClick={onCTAClose} />
          </Box>
        </CTAContainer>
      </RWD.Mobile>
    ) : null
  }
  const CTAText = props => {
    if (new Date() < lecture.soldAt.toDate()) {
      return (
        <Flex {...props} mb={[8, 8, 0, 0]}>
          <Flex mr={8} alignItems="center">
            <Text.ContentMain>NT$</Text.ContentMain>
            <Text.HighlightMain>{lecture.earlyPrice}</Text.HighlightMain>
          </Flex>
          <Box mr={12}>
            <Text.ContentGray>
              {moment(lecture.soldAt.toDate()).format('MM/DD')}前早鳥
            </Text.ContentGray>
          </Box>
          <Box>
            <Text.ContentGray style={{ textDecoration: 'line-through' }}>
              原價NT${lecture.listPrice}
            </Text.ContentGray>
          </Box>
        </Flex>
      )
    } else if (new Date() < lecture.startedAt.toDate()) {
      return (
        <Flex {...props}>
          <Box>
            <Text.ContentMain>NT$</Text.ContentMain>
          </Box>
          <Box>
            <Text.HighlightMain>{lecture.listPrice}</Text.HighlightMain>
          </Box>
        </Flex>
      )
    } else if (new Date() < lecture.endedAt.toDate()) {
      return (
        <Flex {...props}>
          <Box>
            <Text.ContentMain>NT$</Text.ContentMain>
          </Box>
          <Box mr={2}>
            <Text.HighlightMain>{lecture.listPrice}</Text.HighlightMain>
          </Box>
          <Box>
            <Text.Content>講座開始囉！快來參與討論</Text.Content>
          </Box>
        </Flex>
      )
    } else {
      return (
        <Flex {...props}>
          <Box>
            <Text.ContentMain>NT$</Text.ContentMain>
          </Box>
          <Box mr={2}>
            <Text.HighlightMain>{lecture.listPrice}</Text.HighlightMain>
          </Box>
          <Box>
            <Text.Content>取得所有完整內容</Text.Content>
          </Box>
        </Flex>
      )
    }
  }
  return (
    <CTAContainer>
      <RWD.Default>
        <Flex justifyContent="space-between" flex={1}>
          <CTAText justifyContent="center" alignItems="center" />
          <Box width={180}>
            <Link to={`/payment?lectureId=${lectureId}`}>
              <Button color="orange" size="large" fluid={true}>
                立即參與
              </Button>
            </Link>
          </Box>
        </Flex>
      </RWD.Default>
      <RWD.Mobile>
        <Flex flexDirection="column" width="100%">
          <CTAText justifyContent="center" alignItems="center" mb={12} />
          <Box>
            <Link to={`/payment?lectureId=${lectureId}`}>
              <Button color="orange" size="large" fluid={true}>
                立即參與
              </Button>
            </Link>
          </Box>
        </Flex>
      </RWD.Mobile>
    </CTAContainer>
  )
}

const ControllerContainer = styled(Flex)`
  width: 176px;
  justify-content: space-between;
  @media (max-width: 576px) {
    width: 148px;
  }
`

const Controller = ({
  isLiked,
  isDiscussed,
  lectureContent,
  onDiscussOpen,
  onLike,
  onPlaybackRateSwitch
}: IFooterProps) => {
  return (
    <ControllerContainer>
      <Flex flexDirection="column" onClick={onPlaybackRateSwitch}>
        <Flex alignItems="center">
          <Icon type={`multiple-${lectureContent.playbackRateIdx}`} />
        </Flex>
        <RWD.Default>
          <Box>
            <Text.LabelGray>倍數</Text.LabelGray>
          </Box>
        </RWD.Default>
      </Flex>
      <Flex>
        <Divider vertical={true} />
      </Flex>
      <Flex flexDirection="column" onClick={onLike}>
        <Flex alignItems="center">
          {isLiked ? (
            <Icon type="lecture-like" />
          ) : (
            <Icon type="lecture-like-o" />
          )}
        </Flex>
        <RWD.Default>
          <Box>
            <Text.LabelGray>喜歡</Text.LabelGray>
          </Box>
        </RWD.Default>
      </Flex>
      <Flex flexDirection="column" onClick={onDiscussOpen}>
        <Flex alignItems="center">
          {' '}
          {isDiscussed ? (
            <Icon type="lecture-comment" />
          ) : (
            <Icon type="lecture-comment-o" />
          )}
        </Flex>
        <RWD.Default>
          <Box>
            <Text.LabelGray>討論</Text.LabelGray>
          </Box>
        </RWD.Default>
      </Flex>
    </ControllerContainer>
  )
}

interface IConnectProps {
  lecture: ILecture | null
}
type IFooterProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch> &
  IConnectProps

class Footer extends React.Component<IFooterProps> {
  public state = {
    showCTA: true
  }
  public handleCTAClose = () => {
    this.setState({ showCTA: false })
  }
  public render() {
    const {
      lectureId,
      isSpeaker,
      isParticipant,
      lectureContent,
      currentLecture,
      currentInsight,
      onPlayingSwitch
    } = this.props
    const progress = `${moment(
      lectureContent.progress.playedSeconds * 1000
    ).format('mm:ss')}/${moment(
      lectureContent.progress.loadedSeconds * 1000
    ).format('mm:ss')}`

    return (
      <FooterContainer>
        {currentLecture && lectureContent.currentMaterialIdx >= 0 ? (
          <React.Fragment>
            <ToolbarContainer>
              <Flex alignItems="center">
                <Box mr={12}>
                  <Icon
                    size={36}
                    type={lectureContent.isPlaying ? 'stop' : 'play'}
                    onClick={onPlayingSwitch}
                  />
                </Box>
                <RWD.Mobile>
                  <Box>
                    <Text.LabelGray>{progress}</Text.LabelGray>
                  </Box>
                </RWD.Mobile>
                <RWD.Default>
                  <Flex flexDirection="column">
                    <Box>
                      {
                        currentLecture.units[0].chapters[
                          lectureContent.currentChapterIdx
                        ].title
                      }
                    </Box>
                    <Box>
                      <Text.LabelGray>
                        {currentInsight ? currentInsight.text : null}
                        {' | '}
                        {progress}
                      </Text.LabelGray>
                    </Box>
                  </Flex>
                </RWD.Default>
              </Flex>
              <Flex alignItems="center">
                <Controller {...this.props} />
                {!isParticipant && !isSpeaker && (
                  <RWD.Default>
                    <Box ml={28} width={180}>
                      <Link to={`/payment?lectureId=${lectureId}`}>
                        <Button color="orange" size="large" fluid={true}>
                          立即參與
                        </Button>
                      </Link>
                    </Box>
                  </RWD.Default>
                )}
              </Flex>
            </ToolbarContainer>
            {!isParticipant && !isSpeaker && (
              <RWD.Mobile>
                <Box width="100%" px={12} pb={16}>
                  <Link to={`/payment?lectureId=${lectureId}`}>
                    <Button color="orange" size="medium" fluid={true}>
                      立即參與
                    </Button>
                  </Link>
                </Box>
              </RWD.Mobile>
            )}
          </React.Fragment>
        ) : (
          <CTAFooter
            {...this.props}
            isShow={this.state.showCTA}
            onCTAClose={this.handleCTAClose}
          />
        )}
      </FooterContainer>
    )
  }
}

const mapState = ({
  auth,
  lectureContent,
  lectures,
  participants,
  discussion,
  insights
}: RootState) => {
  const lectureId = lectureContent.currentLectureId
  const currentUser = firebase.auth().currentUser
  const currentLecture =
    lectureId && lectures[lectureId] ? lectures[lectureId] : null
  const isSpeaker =
    currentLecture !== null &&
    currentUser !== null &&
    R.contains(currentUser.uid, currentLecture.speakerIds)
  const isParticipant =
    lectureId &&
    currentUser !== null &&
    participants[lectureId] !== null &&
    participants[lectureId] !== undefined &&
    R.contains(currentUser.uid, participants[lectureId])
  const currentInsight = lectureContent.currentInsightId
    ? insights[lectureContent.currentInsightId]
    : null
  const usersLiked = currentInsight
    ? currentInsight.materials[lectureContent.currentMaterialIdx].reactions.like
    : []
  return {
    lectureId,
    currentLectureId: lectureContent.currentLectureId,
    isSpeaker,
    isParticipant,
    currentLecture,
    currentInsight,
    lectureContent,
    isDiscussed: discussion.isOpen,
    isLiked:
      auth.isAuthenticated &&
      currentUser !== null &&
      R.contains(currentUser.uid, usersLiked)
  }
}

const mapDispatch = (dispatch: Dispatch) => {
  return {
    onPlayingSwitch: () => dispatch.lectureContent.switchPlaying(),
    onPlaybackRateSwitch: () => dispatch.lectureContent.switchPlaybackRate(),
    onLike: () => {
      const { lectureContent } = store.getState()
      const {
        currentLectureId,
        currentChapterIdx,
        currentInsightId,
        currentMaterialIdx
      } = lectureContent
      dispatch.insights
        .toggleReaction({
          lectureId: currentLectureId || '',
          chapterIdx: currentChapterIdx,
          insightId: currentInsightId || '',
          materialIdx: currentMaterialIdx,
          reaction: 'like'
        })
        .catch(err => alert(err.message))
    },
    onDiscussOpen: () => {
      const { lectureContent } = store.getState()
      const {
        currentChapterIdx,
        currentInsightId,
        currentMaterialIdx
      } = lectureContent
      dispatch.discussion.changeCurrentDiscussion({
        chapterIdx: currentChapterIdx,
        insightId: currentInsightId || '',
        materialIdx: currentMaterialIdx
      })
    }
  }
}
export default connect(
  mapState,
  mapDispatch
)(Footer)



// WEBPACK FOOTER //
// ./src/pages/LectureContentPage/Footer.tsx